import { render } from "./PropertyColor.vue?vue&type=template&id=080933b0"
import script from "./PropertyColor.vue?vue&type=script&lang=js"
export * from "./PropertyColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__